import apiConfig from "@/config/apiConfig";

const rootPath = apiConfig.companyApi;

// 企业招聘
export const enterpriseRrecruitmentInfo = {
  pageList: rootPath + "/talentCompanyJobOpenings/pageList", // 分页查询(get)
  noPageList: rootPath + "/talentCompanyJobOpenings/list",  // 不分页
  detail: rootPath + "/talentCompanyJobOpenings/detail",     // 详情
  add: rootPath + "/talentCompanyJobOpenings/add",   // 新增
  edit: rootPath + "/talentCompanyJobOpenings/update",      // 修改
  remove: rootPath + "/talentCompanyJobOpenings/remove/",   // 删除
}

// 企业邀请面试  type 0主动发起 1被动接受
export const companyInvitedInfo = {
  pageList: rootPath + "/talentInterviewInvitation/talentCompanyView", // 分页查询(get)
}

// 企业人才
export const enterpriseTalentInfo = {
  pageList: rootPath + "/talentCompanyResume/pageList", // 分页查询(get)
  detail: rootPath + "/talentCompanyResume/detail",     // 详情
  remove: rootPath + "/talentCompanyResume/remove/",   // 删除
  saveupdate: rootPath + "/talentCompanyResume/saveOrUpdate",   // 新增/修改
  bulkExportExcel: rootPath + "/talentCompanyResume/exportExcel",  // 批量导出
}

// 企业中心适合我的
export const personalRecommendationInfo = {
  pageList: rootPath + "/talentUser/getJobRecommend",
}

// 个人中心
export const personalCenterInfo = {
  pageList: rootPath + "/talentUser/pagelist", // 分页查询(get)
  detail: rootPath + "/talentUser/detail",     // 未算工作年限和年龄详情
  userDetail: rootPath + "/talentUser/getUserInfo",  // 算了的详情
  saveupdate: rootPath + "/talentUser/insertOrupdate",   // 新增/修改
}

// 简历信息-工作经历
export const workExpriseInfo = {
  pageList: rootPath + "/talentUserWorkExperience/pageList", // 分页查询(get)
  detail: rootPath + "/talentUserWorkExperience/detail",     // 详情
  remove: rootPath + "/talentUserWorkExperience/remove/",   // 删除
  saveupdate: rootPath + "/talentUserWorkExperience/saveOrUpdate",   // 新增/修改
}

// 简历信息-教育经历
export const eduExpriseInfo = {
  pageList: rootPath + "/talentUserEducationalExperience/pageList", // 分页查询(get)
  detail: rootPath + "/talentUserEducationalExperience/detail",     // 详情
  remove: rootPath + "/talentUserEducationalExperience/remove/",   // 删除
  saveupdate: rootPath + "/talentUserEducationalExperience/saveOrUpdate",   // 新增/修改
}

// 简历信息-项目经验
export const projectExpriseInfo = {
  pageList: rootPath + "/talentUserProjectExperience/pageList", // 分页查询(get)
  detail: rootPath + "/talentUserProjectExperience/detail",     // 详情
  remove: rootPath + "/talentUserProjectExperience/remove/",   // 删除
  saveupdate: rootPath + "/talentUserProjectExperience/saveOrUpdate",   // 新增/修改
}

// 个人简历投递 面试邀请   type 0 主动  1 被动
export const talentUserViewInfo = {
  pageList: rootPath + "/talentInterviewInvitation/talentUserView", // 分页查询(get)
}

// 接不接受面试邀请
export const isPassInfo = {
  isPass: rootPath + "/talentInterviewInvitation/checkIsPass"
}

// 企业适合我的   按钮
export const personalRecommendation = {
  isPass: rootPath + "/talentUser/makeInvitation"
}

// 个人适合我的   按钮
export const jobRecommendation = {
  isPass: rootPath + "/talentUser/initiatingInterview"
}

// 求职意向
export const employmentIntentionInfo = {
  detail: rootPath + "/talentUserJobIntention/detail",     // 详情
  saveupdate: rootPath + "/talentUserJobIntention/insertOrupdate",   // 新增/修改
}

// 人才补贴
export const talentSubsidyArticlesInfo = {
  detail: rootPath + "/talentSubsidyApplication/detail",     // 详情
  pageList: rootPath + "/talentSubsidyApplication/pageList",   // 新增/修改
}

// 岗位推荐列表
export const jobRecommendationInfo = {
  pageList: rootPath + "/talentUser/getCompanyRecommend",     // 列表
}

// 对接会报名
export const activity = {
  save: rootPath + "/manage/basicsActivityApply/saveOrUpdate",  // 点击报名按钮
}
//  门户
// 首页
export const homeEducationInfo = {
  jobPageList: rootPath + "/web/talentCompanyJobOpenings/pageList", // 科研招聘企业列表
  companyJobList: rootPath + "/web/talentCompanyJobOpenings/getCompanyJobs", // 某一企业所有岗位列表
  companyDetail: rootPath + "/web/talentCompanyJobOpenings/getCompanyInfo", // 某一企业信息
  zhikuList: rootPath + "/web/talentThinkTank/pageList",  //  智库列表
  zhikuDetail: rootPath + "/web/talentThinkTank/detail",  //  智库详情
  talentpolicyList: rootPath + "/web/talentSubsidyArticles/pageList",   // 人才政策列表
  talentpolicyDetail: rootPath + "/web/talentSubsidyArticles/detail",  //人才政策详情
  applyTalentPolicy: rootPath + "/talentSubsidyApplication/mySave", // 人才政策申请按钮
  findpeopleList: rootPath + "/web/talentRelease/pageList",  //  找人才列表
  findpeopleDetail: rootPath + "/web/talentRelease/detail",  //  找人才列表
  dockingmeetingList: rootPath + "/web/basicsActivityInfo/pageList", // 专场对接会列表
  dockingmeetingDetail: rootPath + "/web/basicsActivityInfo/detail", // 专场对接会详情
}
// 创业导师
export const entrepreneurshipMentor = {
  pageList: rootPath + "/web/talentUserTutor/pageList",     // 列表
  detail: rootPath + "/web/talentUserTutor/detailId",  // 详情
}